var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('company-staff-and-permissions',{ref:"company_staff_and_permission",attrs:{"store_url":_vm.store_url,"roles":_vm.roles,"company_staff_url":_vm.company_staff_url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }